const CaSetting = [
  {
    key: "S19A(1) 3 years",
    caType: "S19A",
    caSummary: "S19A(1)",
    startPeriod: null,
    endPeriod: null,
    isFieldVariable: {
      numberOfYears: false,
      IA: false,
    },
    numberOfYears: 3,
    allowanceType: {
      AA: true,
      IA: false,
    },
    straightLineMethod: true,
    IA: null,
    AAbreakdown: [33.3, 33.3, 33.4],
    baseAllowanceCap: false,
    cap: null,
    enhancedAllowance: false,
    enhancedAllowancePercentage: 0,
    furtherAllowanceCap: null,
    isEditable: false,
    isOnlyEnhanced: false,
  },
  {
    key: "S19A(1) 2 years",
    caType: "S19A",
    caSummary: "S19A(1)",
    startPeriod: null, // Adjusted for 3 years
    endPeriod: null,
    isFieldVariable: {
      numberOfYears: false,
      IA: false,
    },
    numberOfYears: 2,
    allowanceType: {
      AA: true,
      IA: false,
    },
    straightLineMethod: false,
    IA: null,
    AAbreakdown: [25, 75],
    baseAllowanceCap: false,
    cap: null,
    enhancedAllowance: false,
    enhancedAllowancePercentage: 0,
    furtherAllowanceCap: null,
    isEditable: false,
    isOnlyEnhanced: false,
  },
  {
    key: "S19A(2 to 10) 1 year",
    caType: "S19A",
    caSummary: "S19A(2 to 10A)",
    startPeriod: null, // Adjusted for 3 years
    endPeriod: null,
    isFieldVariable: {
      numberOfYears: false,
      IA: false,
    },
    numberOfYears: 1,
    allowanceType: {
      AA: true,
      IA: false,
    },
    straightLineMethod: true,
    IA: null,
    AAbreakdown: [100],
    baseAllowanceCap: false,
    cap: null,
    enhancedAllowance: false,
    enhancedAllowancePercentage: 0,
    furtherAllowanceCap: null,
    isEditable: false,
    isOnlyEnhanced: false,
  },
  {
    key: "S19A(10A) 1 year - capped",
    caType: "S19A",
    caSummary: "S19A(2 to 10A)",
    startPeriod: null, // Adjusted for 3 years
    endPeriod: null,
    isFieldVariable: {
      numberOfYears: false,
      IA: false,
    },
    numberOfYears: 1,
    allowanceType: {
      AA: true,
      IA: false,
    },
    straightLineMethod: true,
    IA: null,
    AAbreakdown: [100],
    baseAllowanceCap: true,
    cap: 30000,
    enhancedAllowance: false,
    enhancedAllowancePercentage: 0,
    furtherAllowanceCap: null,
    isEditable: false,
    isOnlyEnhanced: false,
  },
  {
    key: "S19",
    caType: "S19",
    caSummary: "S19",
    startPeriod: null, // Adjusted for 3 years
    endPeriod: null,
    isFieldVariable: {
      numberOfYears: true,
      IA: false,
    },
    numberOfYears: null, // Variable
    allowanceType: {
      AA: true,
      IA: true,
    },
    straightLineMethod: true,
    IA: 20,
    AAbreakdown: [],
    baseAllowanceCap: false,
    cap: null,
    enhancedAllowance: false,
    enhancedAllowancePercentage: 0,
    furtherAllowanceCap: null,
    isEditable: false,
    isOnlyEnhanced: false,
  },
  {
    key: "S19B YA 2024 - 28",
    caType: "S19B",
    caSummary: "S19B",
    startPeriod: 2024,
    endPeriod: 2028,
    isFieldVariable: {
      numberOfYears: true,
      IA: true,
    },
    numberOfYears: null, // Variable
    allowanceType: {
      AA: true,
      IA: false,
    },
    straightLineMethod: true,
    IA: null,
    AAbreakdown: [],
    baseAllowanceCap: false,
    cap: null,
    enhancedAllowance: true,
    enhancedAllowancePercentage: 300,
    furtherAllowanceCap: 400000,
    isEditable: false,
    isOnlyEnhanced: true,
  },
  {
    key: "S19B",
    caType: "S19B",
    caSummary: "S19B",
    startPeriod: null,
    endPeriod: null,
    isFieldVariable: {
      numberOfYears: true,
      IA: false,
    },
    numberOfYears: null, // Variable
    allowanceType: {
      AA: true,
      IA: false,
    },
    straightLineMethod: true,
    IA: null,
    AAbreakdown: [],
    baseAllowanceCap: false,
    cap: null,
    enhancedAllowance: false,
    enhancedAllowancePercentage: 0,
    furtherAllowanceCap: null,
    isEditable: false,
    isOnlyEnhanced: false,
  },
  {
    key: "S19D",
    caType: "S19D",
    caSummary: "S19D",
    startPeriod: null,
    endPeriod: null,
    isFieldVariable: {
      numberOfYears: true,
      IA: false,
    },
    numberOfYears: null,
    allowanceType: {
      AA: true,
      IA: false,
    },
    straightLineMethod: true,
    IA: null,
    AAbreakdown: [],
    baseAllowanceCap: false,
    cap: null,
    enhancedAllowance: false,
    enhancedAllowancePercentage: 0,
    furtherAllowanceCap: null,
    isEditable: false,
    isOnlyEnhanced: false,
  },
  {
    key: "S16 - (LIA / IBA)",
    caType: "S16",
    caSummary: ["S16 - LIA", "S16 - IBA"],
    startPeriod: null,
    endPeriod: null,
    isFieldVariable: {
      numberOfYears: true,
      IA: true,
    },
    numberOfYears: null,
    allowanceType: {
      AA: true,
      IA: true,
    },
    straightLineMethod: false,
    IA: null, // Variable
    AAbreakdown: [],
    baseAllowanceCap: false,
    cap: null,
    enhancedAllowance: false,
    enhancedAllowancePercentage: 0,
    furtherAllowanceCap: null,
    isEditable: false,
    isOnlyEnhanced: false,
  },
];

export const getCaSettingByKey = (caSettings, key) => {
  if (["S16 - LIA", "S16 - IBA"].includes(key)) {
    return caSettings.find((setting) => setting.key === "S16 - (LIA / IBA)");
  }

  return caSettings.find((setting) => setting.key === key) || null;
};

export const getCaSettings = (type) => {
  return type
    ? CaSetting.filter((setting) => setting.caType === type)
    : CaSetting;
};

export const getCleanCaKeys = (caSettings) => {
  const result = [];

  caSettings.forEach((setting) => {
    if (setting.key === "S16 - (LIA / IBA)") {
      result.push("S16 - LIA");
      result.push("S16 - IBA");
    } else result.push(setting.key);
  });

  return result;
};

export const getCaKeys = (caSettings) => {
  const result = [];

  caSettings?.forEach((setting) => {
    if (setting.key === "S16 - (LIA / IBA)") {
      const [first, second] = setting.caSummary;
      result.push(first, second);
    } else {
      result.push(setting.key);
    }
  });

  return result;
};

export const getCaByType = (caSettings, type) => {
  return caSettings
    .filter((setting) => setting.caType === type)
    .map((setting) => setting.key);
};

export const getCaType = (caSettings, caName) => {
  if (["S16 - LIA", "S16 - IBA"].includes(caName)) {
    return "S16";
  }

  const found = caSettings.find((setting) => setting.key === caName);

  if (found) return found.caType;

  return "Other Types";
};

export const getCaTypeByCaSummary = (caSettings, caSummary) => {
  if (["S16 - LIA", "S16 - IBA"].includes(caSummary)) {
    return "S16";
  }

  const found = caSettings.find((setting) => setting.caSummary === caSummary);

  if (found) return found.caType;

  return "Other Types";
};

export const getCaSummary = (caSettings, key) => {
  if (["S16 - LIA", "S16 - IBA"].includes(key)) {
    return key;
  }

  const setting = getCaSettingByKey(caSettings, key);
  return setting ? setting.caSummary : null;
};

export const someEnhancedAllowanceTrue = (settings) => {
  return settings.some((item) => item.enhancedAllowance === true);
};

export const getAAbreakdown = (numberOfYears, IA = 0) => {
  const years = parseInt(numberOfYears, 10);
  const initialAllowance = parseFloat(IA) || 0; // Ensure IA is a valid number

  if (
    isNaN(years) ||
    years <= 0 ||
    initialAllowance < 0 ||
    initialAllowance > 100
  )
    return [];

  // Ensure IA is within valid range
  const availableForAA = 100 - initialAllowance;
  if (availableForAA <= 0) return []; // No AA if IA is 100%

  const evenSplit = (availableForAA / years).toFixed(2); // Split remaining % evenly
  const breakdown = Array(years).fill(parseFloat(evenSplit));

  // Adjust last element to ensure total (IA + AA Breakdown) is exactly 100%
  const totalAA = breakdown.reduce((sum, val) => sum + val, 0);
  const difference = availableForAA - totalAA;
  breakdown[breakdown.length - 1] += difference;

  return breakdown;
};
